export default {"src":"/_next/static/media/stressMotivationMobile.2b67a90d.svg","height":228,"width":272,"blurWidth":0,"blurHeight":0};